import React, { useState } from "react";
import emailjs from "emailjs-com";
import HeaderInner from "../header/HeaderInner";
import Footer from "../elements/Footer";
import { Link } from "react-router-dom";

// DATA
import { DataContactOne } from "../data/DataContact";
import { DataNav } from "../data/DataNav";
import Breadcrumb from "./Breadcrumb";

function ContactPage() {
  // Initialize DataContactOne
  const dataContact = DataContactOne;

  const dataBreadcrumb = DataNav[6];

  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    subject: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs
      .send(
        "YOUR_SERVICE_ID", // Replace with your EmailJS service ID
        "YOUR_TEMPLATE_ID", // Replace with your EmailJS template ID
        formData,
        "YOUR_USER_ID" // Replace with your EmailJS user ID
      )
      .then(
        (response) => {
          console.log("SUCCESS!", response.status, response.text);
          alert("Message sent successfully!");
        },
        (err) => {
          console.log("FAILED...", err);
          alert("Failed to send message. Try again.");
        }
      );

    setFormData({
      name: "",
      phone: "",
      email: "",
      subject: "",
      message: "",
    });
  };

  return (
    <div className="service-details contact-page">
      <div className="">
        <HeaderInner />
        <main>
          <Breadcrumb props={dataBreadcrumb} />

          {/* tmp contact area */}
          <div className="contact-area tmp-section-gap">
            <div className="container">
              <div className="row g-5">
                <div className="col-lg-7">
                  <div className="contact-inner">
                    <div className="section-head section-head-one-side text-align-left">
                      <span className="title">
                        {dataContact?.sectionName}{" "}
                        <span style={{ color: "rgb(14 120 190)" }}>
                          SETELEC-CI
                        </span>
                      </span>
                      <p className="description">{dataContact?.desc}</p>
                    </div>
                    <ul className="ft-link ft-link-style-three">
                      <li>
                        <div className="single-contact background-transparent">
                          <div className="icon">
                            <i className="fa-light fa-phone" />
                          </div>
                          <div className="content">
                            <span>Téléphone</span>
                            <a
                              className="contact-here"
                              href={`tel:${dataContact?.phone}`}
                            >
                              {dataContact?.phone}
                            </a>
                            {"  "}
                            <a
                              className="contact-here"
                              href={`tel:${dataContact?.phone2}`}
                            >
                              {dataContact?.phone2}
                            </a>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="single-contact background-transparent">
                          <div className="icon">
                            <i className="fa-solid fa-envelope-open-text" />
                          </div>
                          <div className="content">
                            <span>E-mail</span>
                            <a
                              className="contact-here"
                              href={dataContact?.email}
                            >
                              {dataContact?.email}
                            </a>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="single-contact background-transparent">
                          <div className="icon">
                            <i className="fa-regular fa-map-location-dot" />
                          </div>
                          <div className="content">
                            <span>Siège</span>
                            <a
                              className="contact-here"
                              target="_blank"
                              href={dataContact?.googleMap}
                            >
                              {dataContact?.address}
                            </a>
                          </div>
                        </div>
                      </li>
                    </ul>
                    <div className="tmp-tag-list tag-list-one">
                      {dataContact?.mediaLinks.map((item) => {
                        return (
                          <Link key={item.id} className="tag-list" to="#">
                            {item.name}
                          </Link>
                        );
                      })}
                    </div>
                  </div>
                </div>
                <div className="col-lg-5">
                  <div className="contact-inner">
                    <div className="section-head section-head-one-side text-align-left">
                      <span className="title">{dataContact?.contactTitle}</span>
                      <p className="description">{dataContact?.contactDesc}</p>
                    </div>
                    <div className="contact-form style-two">
                      <div id="form-messages" />
                      <form id="contact-form" onSubmit={handleSubmit}>
                        <div className="contact-form-wrapper row">
                          <div className="col-lg-6">
                            <div className="form-group">
                              <input
                                className="input-field"
                                name="name"
                                placeholder="Name"
                                id="contact-name"
                                type="text"
                                value={formData.name}
                                onChange={handleChange}
                                required
                              />
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="form-group">
                              <input
                                className="input-field"
                                name="phone"
                                placeholder="Phone"
                                type="text"
                                value={formData.phone}
                                onChange={handleChange}
                                required
                              />
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="form-group">
                              <input
                                className="input-field"
                                name="email"
                                placeholder="Email"
                                type="email"
                                value={formData.email}
                                onChange={handleChange}
                                required
                              />
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="form-group">
                              <input
                                className="input-field"
                                name="subject"
                                placeholder="Subject"
                                type="text"
                                value={formData.subject}
                                onChange={handleChange}
                                required
                              />
                            </div>
                          </div>
                          <div className="col-lg-12">
                            <div className="form-group">
                              <textarea
                                className="input-field"
                                name="message"
                                placeholder="How can we help"
                                value={formData.message}
                                onChange={handleChange}
                                required
                                id="contact-message"
                              />
                            </div>
                          </div>
                          <div className="col-lg-12">
                            <div className="form-submit-group">
                              <button
                                className="tmp-btn btn-primary"
                                type="submit"
                              >
                                Envoyer
                              </button>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* tmp contact area */}
          <div className="tmp-map-area tmp-sectiongapBottom">
            <div className="map-area-flotimg-container">
              <iframe
                src={`${dataContact?.mapUrl}`}
                width={600}
                height={650}
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </div>
          <Footer />
        </main>
      </div>
    </div>
  );
}

export default ContactPage;
